import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import {ContactEmail, ContactPhone} from '@jobseeker/lotus/icons';
import {Avatar, Box, Card, Grid, Paper, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';

interface ContactProps {
  contactData: {
    imageSrc: string;
    name: string;
    email: string;
    phone: string;
  }[];
}

interface ContactPropsObj {
  imageSrc: string;
  name: string;
  email: string;
  phone: string;
}

const ContactCard = ({imageSrc, name, email, phone}: ContactPropsObj) => {
  const theme = useWrappedTheme();
  return (
    <>
      <Avatar
        alt={name}
        src={imageSrc}
        sx={{width: 100, height: 100, margin: '0 auto'}}
      />
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          fontSize: theme.typography.pxToRem(20),
          fontWeight: 500,
          color: '#000',
          marginTop: 2,
        }}
      >
        {name}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: 1,
        }}
      >
        <Image src={ContactEmail} alt={'-'} width={25} height={19} />
        <Typography
          variant="body1"
          sx={{
            fontSize: theme.typography.pxToRem(18),
            fontWeight: 300,
            color: '#000',
            marginLeft: 1,
            textAlign: 'center',
          }}
        >
          {email}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: 1,
        }}
      >
        <Image src={ContactPhone} alt={'-'} width={26} height={24} />
        <Typography
          variant="body1"
          sx={{
            fontSize: theme.typography.pxToRem(18),
            fontWeight: 300,
            color: '#000',
            textAlign: 'center',
          }}
        >
          {phone}
        </Typography>
      </Box>
    </>
  );
};
const Contacts = ({contactData}: ContactProps) => {
  const theme = useWrappedTheme();
  return (
    <>
      <Box
        sx={{
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            width: '70%',
            margin: '0 auto',
            textAlign: 'center',
          }}
        >
          <Box
            sx={{
              marginTop: 5,
            }}
          >
            <Typography
              variant="sectionMainHeading"
              sx={{
                clear: 'both',
                marginBottom: 1,
                fontSize: {
                  md: theme.typography.pxToRem(42),
                  xs: theme.typography.pxToRem(22),
                },
              }}
            >
              Contact
            </Typography>
            <Typography
              sx={{
                fontSize: theme.typography.pxToRem(18),
                fontWeight: 300,
                color: '#000',
                display: 'block',
                marginTop: 0.5,
              }}
            >
              For any queries please connect with organisers
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: 4.5,
              marginBottom: 4.5,
              marginLeft: {xs: 0, md: 4},
            }}
          >
            <Grid container spacing={3}>
              {contactData.map(contact => (
                <Grid item key={contact.email} xs={12} sm={6}>
                  <ContactCard {...contact} />
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Contacts;
